import { render, staticRenderFns } from "./MyMenuItem.vue?vue&type=template&id=6d7b4af6"
import script from "./MyMenuItem.vue?vue&type=script&lang=js"
export * from "./MyMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MyMenuItem.vue?vue&type=style&index=0&id=6d7b4af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports